function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Voice_search"
}, /*#__PURE__*/React.createElement("title", null, "VF_voice_search_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 177.2c23.5 0 42.5-19 42.5-42.5V41.2C183.5 17.7 163.9-.7 140.4 0 118 .7 99.9 18.8 99.2 41.2v93.4c.1 23.5 19.1 42.5 42.5 42.6zm-14.2-136c.2-7.8 6.7-14 14.6-13.8 7.5.2 13.6 6.3 13.8 13.8v93.4c-.2 7.8-6.7 14-14.6 13.8-7.5-.2-13.6-6.3-13.8-13.8V41.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.5 134.6c0 35.2-28.6 63.8-63.8 63.8s-63.8-28.6-63.8-63.8H49.6c.1 45.4 33.2 84 78 91v57.8h28.3v-57.8c44.8-7 77.9-45.6 78-91h-28.4z"
}))));